module.exports = __webpack_public_path__ + "img/staci_20_ceny_bytu.051e6b8f.svg";